import axios from "axios";
import settings from "utils/settings";

const { apiUrl } = settings;

export const requestGetServiceReportById = (serviceReportId) =>
    axios.get(`${apiUrl}serviceReports/${serviceReportId}`);
    // axios.get(`${apiUrl}serviceReports/852656`);

export const unSubmitSchedule = (serviceId) =>
    axios.post(`${apiUrl}serviceReports/${serviceId}/UnSubmit`);

export const requestServiceReportUploadPictures = (serviceReportId, images) => {
    const formData = new FormData();
    Array.from(images).forEach(image => {
        formData.append("files", image);
    });

    return axios.post(`${apiUrl}serviceReports/${serviceReportId}/uploadPictures`, formData, {
        headers: {
            "Content-Type": "multipart/form-data",
        }
    });
};

export const requestServiceReportUploadDeficiencyForm = (serviceReportId, images) => {
    const formData = new FormData();
    Array.from(images).forEach(image => {
        formData.append("file", image);
    });
    return axios.post(`${apiUrl}serviceReports/${serviceReportId}/UploadDeficiencyForm`, formData, {
        headers: {
            "Content-Type": "multipart/form-data",
        }
    });
};

export const requestServiceReportUploadSignOffForm = (serviceReportId, images) => {
    const formData = new FormData();
    Array.from(images).forEach(image => {
        formData.append("file", image);
    });
    return axios.post(`${apiUrl}serviceReports/${serviceReportId}/UploadSignOffForm`, formData, {
        headers: {
            "Content-Type": "multipart/form-data",
        }
    });
};


export const requestSaveServiceReport = (data) =>
    axios.put(`${apiUrl}serviceReports`, data);

export const removeImage = (serviceId, image) =>
    axios.delete(`${apiUrl}serviceReports`,{
        data: {
            serviceId:serviceId,
            path: image
        }
    });

